import React from 'react';

const NoticeHeader = ({ headerImgSrc, children }) => {

  const headerImage = (
    <div className="modal-image">
      <img src={headerImgSrc} alt="" />
    </div>
  );

  return (
    <div>
      { headerImgSrc ? headerImage : null }
      <h2 className="h2-bright">
        { children }
      </h2>
    </div>
  )
};

export default NoticeHeader;
